import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import MaterialTable from 'material-table';
import AskAlert from '../common/AskAlert';
import{ SERVER_PATH, AXIOS_CONFIG } from '../common/redux/constantes';

import ConfigureCompany  from './ConfigureCompany';


class ListCompanies extends Component {
  static propTypes = {
    unit: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state ={
    units:[],
    openDeleteAlert:false,
    deleteCompanyID:-1
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }


  handleClickOpen = (company) => {
    this.setState({ openConfigureDialog: true,companySelected:company});
  };


  handleClose = () => {
    this.setState({ openConfigureDialog: false });
    this.refreshTable();
  };

  deleteCompany =()=>{
    if(this.state.deleteCompanyID !== -1){
      this.props.actions.deleteCompany(this.tableRef,this.state.deleteCompanyID);
      this.setState({openDeleteAlert:false});
    }
  }


  cancelDelete = () =>{
    this.setState({openDeleteAlert:false});
  }

  askDeleteCompany= (companyID)=>{
    this.setState({openDeleteAlert:true, deleteCompanyID:companyID});
  }

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }

  render() {

      let actionButtons =[
        rowData => ({
          icon: 'build',
          tooltip: 'Setup Company',
          onClick: (event, rowData) => this.handleClickOpen(rowData)
        }),
        {
          icon: 'delete',
          tooltip: 'Delete',
          onClick: (event, rowData) => this.askDeleteCompany(rowData.company) 
        },
        {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
        }
      ];
      return (
        <div >
          <MaterialTable
          tableRef={this.tableRef}
          
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#fffff',
              color: 'black',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Companies"
          columns={[
            { 
              title: 'Name', 
              field: 'name',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
            { 
              title: 'Phone Number', 
              field: 'phone_number', 
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
            { 
              title: 'Address', 
              field: 'address', 
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/companies/getAll'
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                resolve({
                  data: result.companies,
                  page: 0,
                  totalCount: result.companies.length,
                })
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }

          actions={actionButtons}
        />
        <AskAlert openAlert={this.state.openDeleteAlert} handleCloseCancel={this.cancelDelete} handleCloseOk={this.deleteCompany}
          dialogTitle="Delete Company" dialogContent="Are you sure to delete this company?" />
          <ConfigureCompany  company_selected={this.state.companySelected} open={this.state.openConfigureDialog}  handleClose={this.handleClose} action={this.state.action}/>
        </div>
      )
    }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    company: state.company,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListCompanies);



// WEBPACK FOOTER //
// ./src/features/company/ListCompanies.js